import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowRight } from "lucide-react";
import { LOGO_URL } from "../data/constants";
import { useCurrency } from "../contexts/CurrencyContext";

export const Footer = () => {
  const { contactInfo, isUAE } = useCurrency();

  return (
    <footer className="bg-gray-dark text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <img
              src={LOGO_URL}
              alt="FunAsia Digital"
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 text-sm mb-4">
              SmartReach&trade; · Drive Real Customers To Your Business
            </p>
            <p className="text-gray-400 text-sm">
              The advertising platform that turns local audiences into walk-in customers.
            </p>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {["Home", "Services", "Pricing", "About", "Contact"].map((item) => (
                <li key={item}>
                  <Link
                    to={item === "Home" ? "/" : `/${item.toLowerCase()}`}
                    className="text-gray-400 hover:text-orange-secondary transition-colors text-sm"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              {[
                { name: "SmartReach\u2122 Platform", path: "/smartreach" },
                { name: "Foot Traffic Marketing", path: "/foot-traffic-marketing" },
                { name: "Loyalty Platform", path: "/loyalty-platform" },
                { name: "Programmatic DSP", path: "/dsp" },
                { name: "AI Receptionist", path: "/services" },
                { name: "Local Listings", path: "/services" }
              ].map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.path}
                    className="text-gray-400 hover:text-orange-secondary transition-colors text-sm"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-400 text-sm">
                <Mail size={16} className="text-orange-secondary" />
                {contactInfo.email}
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm">
                <Phone size={16} className="text-orange-secondary" />
                {contactInfo.phone}
              </li>
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <MapPin size={16} className="text-orange-secondary mt-1" />
                <div>
                  {isUAE ? (
                    <>
                      <div>{contactInfo.address}</div>
                      <div>{contactInfo.addressLine2}</div>
                    </>
                  ) : (
                    contactInfo.location
                  )}
                </div>
              </li>
            </ul>
            <Link
              to="/dsp/get-access"
              className="inline-flex items-center gap-2 mt-4 text-orange-secondary hover:text-orange-primary transition-colors text-sm font-medium"
            >
              Launch DSP <ArrowRight size={14} />
            </Link>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()}{" "}
            {isUAE ? "HOCKWOOD Digital DMCC" : "FunAsia Digital"} — SEO 360. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-gray-400 hover:text-orange-secondary text-sm">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-400 hover:text-orange-secondary text-sm">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
